import { useState } from 'react';
import PageHeader from './PageHeader';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { TrustBar } from '../shared/TrustBar';

export default function Layout({ children }: { children: React.ReactNode }) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: 'var(--bg-base)',
        transition: 'background-color 0.2s ease'
      }}
    >
      <Sidebar mobileOpen={mobileSidebarOpen} onMobileClose={() => setMobileSidebarOpen(false)} />
      <div className="md:pl-64 flex flex-col" style={{ minHeight: '100vh' }}>
        <TrustBar />
        <PageHeader onMobileMenuToggle={() => setMobileSidebarOpen((v) => !v)} />
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
}
